import SurveyResponseBubble from './SurveyResponseBubble.vue'
export default SurveyResponseBubble
export { SurveyResponseBubble }